import { Program } from '@/services/Investment.service';

import { ProgramChangeReviewProps } from '../ProgramChanges/ProgramChangeReview.component';

export const setInitialMappings = (
  oldProgram: Program,
  newProgram: Program,
  context: ProgramChangeReviewProps['mappingTableContext']
) => {
  const results = [];

  if (
    oldProgram.targetDateSeriesId &&
    oldProgram.targetDateSeriesId === newProgram.targetDateSeriesId
  ) {
    results.push(
      ...(oldProgram?.targetModels?.map?.(({ targetModelId }) => ({
        newModelId: targetModelId,
        newType: 'target',
        oldModelId: targetModelId,
        oldType: 'target'
      })) || [])
    );
  }

  if (
    oldProgram?.nliSeries?.targetSeriesId &&
    oldProgram?.nliSeries?.targetSeriesId ===
      newProgram?.nliSeries?.targetSeriesId
  ) {
    results.push(
      ...(oldProgram?.nliModels?.map?.(({ targetModelId }) => ({
        newModelId: targetModelId,
        newType: 'nli',
        oldModelId: targetModelId,
        oldType: 'nli'
      })) || [])
    );
  }

  if (
    oldProgram.goalSeriesId &&
    oldProgram.goalSeriesId === newProgram.goalSeriesId
  ) {
    results.push(
      ...(oldProgram?.goalSeries?.goePortfolioIds?.map?.(portfolioId => ({
        newPortfolioId: portfolioId,
        newType: 'goal',
        oldPortfolioId: portfolioId,
        oldType: 'goal'
      })) || [])
    );
  }

  if (
    oldProgram.riskSeriesId &&
    oldProgram.riskSeriesId === newProgram.riskSeriesId
  ) {
    results.push(
      ...(oldProgram?.riskModels?.map?.(({ riskModelId }) => ({
        newModelId: riskModelId,
        newType: 'risk',
        oldModelId: riskModelId,
        oldType: 'risk'
      })) || [])
    );
  }

  if (
    oldProgram?.fundLineup?.fundLineupFunds?.length &&
    newProgram?.fundLineup?.fundLineupFunds?.length
  ) {
    results.push({
      mappings: oldProgram.fundLineup.fundLineupFunds.reduce(
        (acc, { cusip }) => {
          if (
            newProgram.fundLineup.fundLineupFunds.some(
              newFund => newFund.cusip === cusip
            )
          ) {
            acc.push({
              newCusip: cusip,
              oldCusip: cusip
            });
          }

          return acc;
        },
        []
      ),
      newType: 'pmenu',
      oldType: 'pmenu'
    });
  }

  context.setChanges(results);
};
